import {put,takeEvery} from 'redux-saga/dist/redux-saga-effects-npm-proxy.esm';

import {TYPES as COMMENT_TO_MODERATE_TYPE} from '../creators/user.comment.to-moderate';

export function* deleteSuccess(action) {
    try {
        yield put({type: "COMMENTS_TO_MODERATE_DELETE", data : action.payload});
        yield put({type: "COMMENTS_MODERATION_DELETE", data : action.payload});

    } catch (error) {

    }
}

export function* updateSuccess(action) {
    try {
        yield put({type: "COMMENTS_TO_MODERATE_UPDATE", data : action.payload});
        yield put({type: "COMMENTS_MODERATION_UPDATE", data : action.payload});
    } catch (error) {

    }
}

export function* watchUserCommentstoModerate() {
    yield takeEvery(COMMENT_TO_MODERATE_TYPE.DELETE_SUCCESS, deleteSuccess);
    yield takeEvery(COMMENT_TO_MODERATE_TYPE.UPDATE_SUCCESS, updateSuccess);
}

export default watchUserCommentstoModerate;

